import React, { useMemo } from "react";
import DHSplashScreen from "../component/DHSplashScreen";
import Footer from "../component/Footer";
import DH_Logo from "../images/dh-logo-min-1.svg";
import Prajavani_logo from "../images/prajavani-logo-img.svg";
import India_flag from "../images/india-logo.png";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { toast } from "react-toastify";
import { doesSessionExist } from "supertokens-web-js/recipe/session";
import Cookies from "js-cookie";
import {
  EMAIL_REGEX,
  GENERAL_ERROR_MSG,
  PHONE_NUMBER_REGEX,
  PRAJAVANI_URL,
  REDIRECT_URL,
} from "../contant";
import LoaderComponent from "../component/LoaderComponent";
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "../component/Tooltip";
import ErrorComponent from "../component/ErrorComponent";
import { fetchUserData, removeCountryCode } from "../utiles";
import classNames from "classnames";

export default function UpdateEmailOrPhonePage() {
  const callbackUrl = localStorage.getItem("callbackUrl") || "";
  const [isLoadignState, setIsLoadignState] = React.useState(true);
  const [isUserEmailMobileBtnsDisable, setIsUserEmailMobileBtnsDisable] =
    React.useState(false);
  const [inputError, setInputError] = React.useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const fieldNeedsToBeUpdated = location.pathname.includes("/change_email")
    ? "email"
    : location.pathname.includes("/change_phonenumber")
      ? "phone"
      : "";

  const [isInputFocused, setIsInputFocused] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: "",
    phone: "",
  });
  const [userData, setUserData] = React.useState({});

  const handleChange = (e) => {
    let { name, value } = e.target;
    // Sanitize the value if the input name is 'phone'
    if (name === "phone") {
      value = value.replace(/\D/g, "");
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setInputError("");
  };

  React.useEffect(() => {
    const isAuthorized = async () => {
      try {
        const isSessionExist = await doesSessionExist();
        if (!isSessionExist) {
          toast.error("Can't change profile details due to user has not logged in yet, redirecting you to login page");
          setTimeout(() => {
            window.location.replace(
              window.location.origin +
              `/auth?${REDIRECT_URL}=${queryParams.get("redirectUrl")}`
            );
            return;
          }, 5000);
        }
      } catch (error) {
        return;
      } finally {
        setIsLoadignState(false);
      }
    };
    isAuthorized();
  }, []);

  React.useEffect(() => {
    const getUserData = async () => {
      try {
        const userData = await fetchUserData();
        if (fieldNeedsToBeUpdated === "email") {
          setFormData({
            email: userData?.userData?.emails[0] || "",
            phone: "",
          });
          setUserData({
            email: userData?.userData?.emails[0] || "",
            phone: "",
          })
          // setEmail(userData?.userData?.emails[0] || "");
        } else if (fieldNeedsToBeUpdated === "phone") {
          setFormData({
            email: "",
            phone: userData?.userData?.phoneNumbers[0]
              ? removeCountryCode(userData?.userData?.phoneNumbers[0])
              : "",
          });
          setUserData({
            email: "",
            phone: userData?.userData?.phoneNumbers[0]
              ? removeCountryCode(userData?.userData?.phoneNumbers[0])
              : "",
          })
          // setPhoneNumber(userData?.userData?.phoneNumbers[0]);
        }
      } catch (error) {
        toast.error("Failed to fetch User");
        console.log("error", error);
      }
    };
    getUserData();
  }, []);

  React.useEffect(() => {
    if (queryParams.get("emailRequired")) {
      localStorage.setItem("emailRequired", queryParams.get("emailRequired"));
    }
    if (queryParams.get("signupMessage")) {
      localStorage.setItem("signupMessage", queryParams.get("signupMessage"));
    }
    if (queryParams.get("redirectUrl")) {
      localStorage.setItem("callbackUrl", queryParams.get("redirectUrl"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleChange = (e) => {
  //   setEmail(e.target.value);
  //   setInputError("");
  // };

  const updateEmailOrPhoneHandler = async (name) => {
    let inputErrorText,
      field,
      regex,
      apiRouteForUpdateEmailOrPhone,
      reqPayload,
      redirectUrlAfterUpdate;
    if (fieldNeedsToBeUpdated === "email") {
      inputErrorText = isPrajavani ? "ಅಮಾನ್ಯ ಇಮೇಲ್ ಐಡಿ" : "Invalid Email";
      field = formData.email;
      regex = EMAIL_REGEX;
      apiRouteForUpdateEmailOrPhone = "change-email";
      reqPayload = {
        email: formData.email,
      };
      redirectUrlAfterUpdate = "/auth/post_change_email";
    } else {
      inputErrorText = isPrajavani ? "ಮೊಬೈಲ್ ನಂಬರ್ ಮಾನ್ಯವಲ್ಲ" : "Invalid Mobile";
      field = formData.phone;
      regex = PHONE_NUMBER_REGEX;
      apiRouteForUpdateEmailOrPhone = "change-phone-number";
      reqPayload = {
        phoneNumber: `+91${formData.phone}`,
      };
      redirectUrlAfterUpdate = "/auth/post_change_phonenumber";
    }
    if (!field || !regex.test(field)) {
      setInputError(inputErrorText);
      return;
    }
    if (fieldNeedsToBeUpdated === "email") {
      localStorage.setItem("changed_email", formData.email);
    } else {
      localStorage.setItem("changed_phone", formData.phone);
    }
    try {
      setIsUserEmailMobileBtnsDisable(true);
      const updateEmailDataResponse = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/${apiRouteForUpdateEmailOrPhone}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("st-access-token")}`,
          rid: "thirdpartypasswordless",
          redirecturl: callbackUrl,
        },
        data: reqPayload,
      });
      if (updateEmailDataResponse.status === 200) {
        localStorage.setItem(
          "create-otp-response",
          JSON.stringify(updateEmailDataResponse.data)
        );
        toast.info(
          `Please check your ${fieldNeedsToBeUpdated === "email" ? "email" : "phone"
          } for OTP`
        );
        navigate(redirectUrlAfterUpdate);
      }
    } catch (error) {
      console.log("errorMessage", error.response);
      if (error?.response?.status === 409) {
        toast.error(error?.response?.data);
      } else {
        toast.error(GENERAL_ERROR_MSG);
      }
    } finally {
      setIsUserEmailMobileBtnsDisable(false);
    }
  };

  const isPrajavani = useMemo(() => callbackUrl?.toLowerCase()?.includes(PRAJAVANI_URL), [callbackUrl]);

  return (
    <>
      {isLoadignState ? (
        <LoaderComponent label={"Loading..."} />
      ) : (
        <div className="xxl:min-h-dvh xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
          <div className="flex flex-row w-full text-center justify-center lg:pt-8 px-10 md:p-1 xxxl:pt-0 sm:min-h-mobile">
            <DHSplashScreen
              className={
                isPrajavani
                  ? "div-with-bg-prajavani"
                  : ""
              }
              logoImage={
                isPrajavani
                  ? Prajavani_logo
                  : DH_Logo
              }
            />
            <div className="w-1/2 shadow-md rounded-2xl bg-white ml-2 pt-4 sm:w-full sm:ml-0 h-full sm:h-auto sm:flex sm:flex-col">
              <p className="text-gray-900 font-bold mb-6 mt-12 text-[28px]">
                {isPrajavani ? "ನನ್ನ ಪ್ರೊಫೈಲ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ" : "Update My Profile"}
              </p>
              <p className="text-[#999999] mb-6 text-[16px] mt-8 xs:px-4 sm:px-10 lg:px-4 xl:px-12 xxl:px-24">
                {localStorage.getItem("signupMessage") && localStorage.getItem("signupMessage") !== "null" ? localStorage.getItem("signupMessage") : (
                  isPrajavani
                    ?
                    (fieldNeedsToBeUpdated === "email" ? 
                      (formData.email 
                        ?`ಈ ಖಾತೆಯೊಂದಿಗೆ ಸಂಬಂಧ ಹೊಂದಿರುವ ಇಮೇಲ್ ಐಡಿ ${userData?.email} ಆಗಿರುತ್ತದೆ. ಈ ಖಾತೆಯೊಂದಿಗೆ ನೀವು ಬಳಸಬೇಕೆಂದಿರುವ ಹೊಸ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ದಯವಿಟ್ಟು ನಮೂದಿಸಿ.`
                        :"ಕಾಮೆಂಟ್ ಮಾಡಲು ಪ್ರಾರಂಭಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ")
                      : `ಈ ಖಾತೆಯೊಂದಿಗೆ ಸಂಯೋಜಿತವಾಗಿರುವ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ${userData?.phone}. ದಯವಿಟ್ಟು ನೀವು ಖಾತೆಯೊಂದಿಗೆ ಬಳಸಲು ಬಯಸುವ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.`)
                    :
                    (fieldNeedsToBeUpdated === "email" ? "Please enter your email address to start commenting" : "Please enter your phone number to start commenting")
                )}
              </p>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="w-full flex justify-center items-center mt-4">
                  <div className="w-full px-8 lg:px-4 md:px-6">
                    <div className="w-full flex justify-center items-center px-16 lg:px-16 md:px-16 sm:px-4">
                      {inputError ? (
                        <>
                          {(fieldNeedsToBeUpdated === "email" &&
                            formData.email === "") ||
                            (fieldNeedsToBeUpdated === "phone" &&
                              formData.phone === "") ? (
                            <Tooltip className="w-full" />
                          ) : (
                            <ErrorComponent
                              errorMsg={inputError}
                              onClick={() => setInputError("")}
                              className={
                                "w-full lg:w-full md:w-full sm:w-full xs:w-full sm:pr-4"
                              }
                            />
                          )}
                        </>
                      ) : (
                        <div className="mt-0"></div>
                      )}
                    </div>
                    <div className="w-full flex justify-center md:flex-col align-center">
                      {fieldNeedsToBeUpdated === "email" ? (
                        <div className="w-full input-field mt-4 text-left px-16 md:px-0 lg:px-8">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder={isPrajavani ? "ನಿಮ್ಮ ಇಮೇಲ್ ಐಡಿ ದಾಖಲಿಸಿ" : "Enter email id"}
                            className={`form-control bg-grey-2/20 text-grey-2 backdrop-blur-sm  border-[1px] border-gray-400/75 border-solid ${inputError &&
                              "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                              }`}
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      ) : (
                        <div className="w-full input-field mt-4 text-left px-16 md:px-0 lg:px-8">
                          <div
                            className="w-full flex justify-center items-center md:w-full"
                            style={{ paddingBottom: "0.5px" }}
                          >
                            <button
                              className={`flex items-center gap-1 text-base text-gray-500 px-4 md:px-2 py-2 border border-solid border-gray-300 border-r-0 pointer-events-none shadow-sm rounded-md rounded-r-none focus:outline-none focus:border-[#087E9E] focus:ring-1 focus:ring-[#087E9E] ${(inputError || isInputFocused) &&
                                "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                                }`}
                              type="button"
                            >
                              <img
                                src={India_flag}
                                alt="flag"
                                className="items-center max-w-8 h-auto"
                              />{" "}
                              +91
                            </button>
                            <input
                              type="tel"
                              name="phone"
                              id="phone"
                              maxLength={10}
                              className={`w-full lg:w-full md:w-full sm:w-full xs:w-full text-base text-gray-500 pl-3.5 sm:pl-1.5 pr-3.5 sm:pr-2 py-3 pt-[13px] border border-solid border-gray-300 border-l-0 focus:outline-none focus:border-[#087E9E] focus:ring-1 focus:ring-[#087E9E] shadow-sm rounded-md rounded-l-none ${inputError &&
                                "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                                }`}
                              placeholder={isPrajavani ? "ನಿಮ್ಮ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ" : "Enter phone number"}
                              value={formData.phone}
                              onChange={handleChange}
                              onFocus={() => {
                                setIsInputFocused(true);
                              }}
                              onBlur={() => {
                                setIsInputFocused(false);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex justify-center gap-5 px-14 md:px-0 lg:px-8">
                      <button
                        type="submit"
                        className={classNames(`text-base w-full text-white text-center font-semibold rounded-md border-none shadow-sm self-stretch leading-6 tracking-[0px] cursor-pointer h-12 mt-10 md:mt-4 mx-2 md:mx-0 mb-36`, {
                          "pointer-events-none bg-gray-300": isUserEmailMobileBtnsDisable,
                          "bg-[#087E9E]": !isPrajavani,
                          "bg-[#ffbf43]": isPrajavani,
                        })}
                        onClick={() => {
                          updateEmailOrPhoneHandler();
                        }}
                        disabled={isUserEmailMobileBtnsDisable}
                      >
                        {isPrajavani ? "ಮುಂದುವರಿಸಿ" : "Continue"}
                      </button>
                      <button
                        type="button"
                        className={`text-base w-full text-white text-center font-semibold rounded-md bg-slate-500 border-none shadow-sm self-stretch leading-6 tracking-[0px] cursor-pointer h-12 mt-10 md:mt-4 mx-2 md:mx-0 mb-36 ${isUserEmailMobileBtnsDisable
                            ? "pointer-events-none !bg-gray-200"
                            : ""
                          }`}
                        onClick={() => {
                          window.location.assign(
                            `${callbackUrl}`
                          );
                        }}
                      >
                        {isPrajavani ? "ರದ್ದುಗೊಳಿಸಿ" : "Cancel"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <Footer
                footerLable={isPrajavani ? "ನಿಮ್ಮ ಲಾಗಿನ್, ಈಗ ಸರಳ" : "Your Login, Simplified"}
                className="sm:mt-auto"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
